import React from "react";
import { NonStreamReportValue } from "@frameworks/web/components/features/Markets/Equity/commonTablemethods";
import ReportsGenericTable from "@frameworks/web/components/generic/ReportsGenericTable";
import PNLScripDetailHead from "./PNLScripDetailHead";
import FilterFlags from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/FilterFlags";
import { NuvamaAssets, NuvamaProducts, } from "@domains/aggregates/interfaces/Reports/iPNLReport";
/**
 *
 * @param props
 * @returns all transactions Table of selected scripIdentifier ,fetched from all tranactions of given snapshot
 */
const AlltxnsOfSelectedScrip = (props) => {
    const THTableColumnViewAllColoums = [
        {
            columnName: "",
            keysForCustomFunction: ["editable", "tranId", "scripIdentifier"],
            tdCustomFunction: (keys) => {
                if (keys[0]) {
                    return (React.createElement("div", null,
                        React.createElement("i", { className: "edel-icon-edit" })));
                }
                return null;
            },
            columnClassName: "brd-left",
            trCustomFunctionOnClickoftd: (e, row) => {
                e.stopPropagation();
                props === null || props === void 0 ? void 0 : props.gotoEditTransaction(row);
            },
            onlyOneArrowAtaTime: true,
            arrowClassName: "justify-end",
        },
        {
            columnName: "Date",
            arrows: true,
            key: "transactionDate",
            applySorting: true,
            type: "Date",
            columnClassName: "text-nowrap",
            tdCustomFunction: (key) => {
                return React.createElement("label", null, key);
            },
            onlyOneArrowAtaTime: true,
        },
        {
            columnName: "Action",
            arrows: true,
            key: "action",
            applySorting: true,
            type: "string",
            onlyOneArrowAtaTime: true,
            tdCustomFunction: (action) => {
                return (React.createElement("span", { className: `DMSanN_16_400 ${action.toUpperCase() === "BUY" ? "txt_green" : "txt_bloodRed"}` }, action.toUpperCase()));
            },
        },
        {
            columnName: "Quantity",
            arrows: true,
            key: "quantity",
            applySorting: true,
            type: "number",
            onlyOneArrowAtaTime: true,
            arrowClassName: "justify-end",
            columnClassName: "common-numeric-arrows numeric-value taRight",
            tdCustomFunction: NonStreamReportValue,
        },
        {
            columnName: "Price",
            arrows: true,
            key: "transactionPrice",
            applySorting: true,
            type: "number",
            tdCustomFunction: NonStreamReportValue,
            onlyOneArrowAtaTime: true,
            arrowClassName: "justify-end",
            columnClassName: "common-numeric-arrows numeric-value taRight",
        },
        {
            columnName: "Brokerage & Charges",
            arrows: true,
            key: "netCharges",
            applySorting: true,
            type: "number",
            tdCustomFunction: NonStreamReportValue,
            onlyOneArrowAtaTime: true,
            arrowClassName: "justify-end",
            columnClassName: "common-numeric-arrows numeric-value taRight",
        },
        {
            columnName: "Net Value",
            arrows: true,
            key: "netValue",
            applySorting: true,
            type: "number",
            tdCustomFunction: NonStreamReportValue,
            onlyOneArrowAtaTime: true,
            arrowClassName: "justify-end",
            columnClassName: "common-numeric-arrows numeric-value taRight",
        },
        {
            columnName: "",
            arrows: false,
            keysForCustomFunction: [
                "edelweissTabShortCode",
                "edelweissProductShortCode",
                "txnFlag",
                "tranId",
                "txnType",
            ],
            tdCustomFunction: (vals) => {
                var _a, _b;
                let [edelweissTabShortCode, edelweissProductShortCode, txnFlag, tranId, txnType,] = vals;
                return (React.createElement(FilterFlags, { rowId: tranId.toString(), parentClass: "justify-content-end pt-1 px-1", filterFlags: {
                        corporateAction: false,
                        research: false,
                        news: false,
                    }, tags: [
                        {
                            tagName: String(edelweissTabShortCode).toLocaleUpperCase(),
                            className: "product-filter-tags orange-light-tag",
                            edelweissProdTooltipDesc: (_a = NuvamaAssets.get(edelweissTabShortCode)) === null || _a === void 0 ? void 0 : _a.display,
                            placement: "top",
                            parentClass: "rebrandreports-tooltip-hover",
                            tagId: tranId + "10",
                        },
                        {
                            tagName: String(edelweissProductShortCode).toLocaleUpperCase(),
                            className: "product-filter-tags orange-light-tag",
                            edelweissProdTooltipDesc: (_b = NuvamaProducts.get(edelweissProductShortCode)) === null || _b === void 0 ? void 0 : _b.display,
                            placement: "top",
                            parentClass: "rebrandreports-tooltip-hover",
                            tagId: tranId + "11",
                        },
                        {
                            tagName: String(txnType).toLocaleUpperCase(),
                            className: "product-filter-tags txn-type",
                            edelweissProdTooltipDesc: txnType,
                            placement: "top",
                            parentClass: "rebrandreports-tooltip-hover",
                            tagId: tranId + "12",
                        },
                    ] }));
            },
            columnClassName: "brd-right",
        },
    ];
    return (React.createElement("div", { className: "mt-4" },
        React.createElement(PNLScripDetailHead, { selectedTxnRow: props.selectedTxnRow }),
        React.createElement(ReportsGenericTable, { columns: THTableColumnViewAllColoums, data: props === null || props === void 0 ? void 0 : props.allTxnsOfSelectedScrip, parentClassName: "common-table-border table", tableClassName: "transaction-history-table", rowClassName: (txn) => ` p-0 ` })));
};
export default AlltxnsOfSelectedScrip;
